import React from 'react';
import classNames from 'classnames';
import styles from '../CitationImportHistory.module.scss';
import { StatBox } from './StatBox';
import { Text, Toggletip } from 'components/core';

export const MergedStatBox = ({ count }: { count: number }) => {
  return (
    <StatBox
      header={
        <Toggletip
          triggerText="Merged"
          idPrefix="merge"
          contentClassName={classNames(styles.mergeToggletipContent)}
        >
          The number of studies that have been merged since this import
        </Toggletip>
      }
      value={<Text size="xxl">{count}</Text>}
    />
  );
};
